import Link, { LinkProps } from 'next/link';
import React from 'react';

type NoLocaleLinkProps = Omit<LinkProps, 'locale'> &
  React.AnchorHTMLAttributes<HTMLAnchorElement> & {
    children?: React.ReactNode;
  };

/**
 * A Link component that disables Next.js automatic locale prefixing.
 * Use this for subdomain-based locale routing (e.g., ru.bina.az)
 * where URLs should not have locale prefixes in the path.
 */
export const NoLocaleLink = React.forwardRef<
  HTMLAnchorElement,
  NoLocaleLinkProps
>(({ children, ...props }, ref) => (
  <Link ref={ref} locale={false} {...props}>
    {children}
  </Link>
));

NoLocaleLink.displayName = 'NoLocaleLink';

export default NoLocaleLink;
